<template v-slot:content>
  <div class="page page-choose-provider">
    <ChooseProvider :context="pageContext" />
  </div>
</template>

<script>
  import ChooseProvider from '@/components/ChooseProvider.vue'
  import { ref, watch } from 'vue'

  export default {
    name: 'page-choose-provider',
    components: {
      ChooseProvider,
    },
    props: {
      context: {
        type: String,
        default: 'home',
      },
    },
    setup(props) {
      const pageContext = ref(props.context)
      watch(
        () => props.context,
        (newValue) => {
          pageContext.value = newValue
        }
      )
      return { pageContext }
    },
  }
</script>

<style lang="scss">
  .page-choose-provider {
    max-width: $content-page-width;
  }
</style>
